module.exports = __webpack_public_path__ + "img/loading.ca0abfb3.png";